import $ from 'jquery';
import Storage from '@component/common/src/util/ClientSideStorage';
import Cookie from '@component/common/src/util/Cookie';
import Coremetrics from '@component/common/src/util/Coremetrics';

export default class ListHeartHandler {
  static heartAddToList(productId, $el, thumbnail) {
    const self = this;
    const userId = Cookie.get('macys_online_uid');
    const url = '/xapi/wishlist/v1/favorites';
    const reqData = {
      CustomerList: {
        list: [{
          items: [{
            qtyRequested: 1,
            product: {
              id: `${productId}`,
            },
          }],
        }],
      },
    };
    if (userId) {
      reqData.CustomerList.user = {
        id: userId,
      };
    }
    $.ajax({
      type: 'POST',
      url,
      data: JSON.stringify(reqData),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done((data, status, jqXHR) => {
        console.log('running done function on wishlist add');
        self.addToListSuccessHandler(data, jqXHR, $el, productId, thumbnail);
      })
      .fail(() => {
        self.showHeartConfirmationMsg('Unable To Add', $el, thumbnail.homepageRecentlyViewedEnabled);
      });
    Coremetrics.createElementTag({
      elementID: 'add_to_wishlist',
      elementCategory: 'search_browse_hearts',
    });
  }
  static heartRemoveFromList(productId, $el, thumbnail) {
    const self = this;
    const listGuid = Storage.getSession('listGuid') || '';
    const url = `/xapi/wishlist/v1/favorites/${listGuid}?productId=${productId}`;
    $.ajax({
      type: 'DELETE',
      url,
      contentType: 'application/json',
      dataType: 'json',
    })
      .done((data, status, jqXHR) => {
        self.removeFromListSuccessHandler(data, jqXHR, $el, productId, thumbnail);
      })
      .fail((jqXHR) => {
        self.removeFromListErrorHandler(jqXHR, $el, productId);
      });
    Coremetrics.createElementTag({
      elementID: 'wishlist_remove',
      elementCategory: 'search_browse_hearts',
    });
  }
  static removeFromListErrorHandler(jqXHR, $el, productId) {
    const self = this;
    if (jqXHR.statusText === 'OK') {
      self.removeFromListSuccessHandler({}, jqXHR, $el, productId);
    } else {
      self.showHeartConfirmationMsg('Unable To Remove', $el);
    }
  }

  static removeFromListSuccessHandler(data, jqXHR, $el, productId, thumbnail) {
    const self = this;
    const listItems = Storage.getSession('listItems');
    const listItemsCount = Storage.getSession('listItemsCount');
    thumbnail.$el.trigger('component::productThumbnail::heartClicked', ['wishlist remove', productId]);
    if (data && data.errors) {
      self.removeFromListErrorHandler(jqXHR, $el);
    } else {
      $el.removeClass('icon-gen-heart-red-large').addClass('icon-gen-heart-gr-large').attr('title', 'Add To Default List').attr('aria-label', 'Add To Default List');
      if (listItems) {
        const listArray = listItems.split(',');
        const index = listArray.indexOf(productId);
        if (index >= 0) {
          listArray.splice(index, 1);
        }
        Storage.setSession('listItems', `${listArray.join(',')}`);
      }
      self.showHeartConfirmationMsg('Removed From List', $el, thumbnail.homepageRecentlyViewedEnabled);
      if (listItemsCount && parseInt(listItemsCount, 10)) {
        Storage.setSession('listItemsCount', parseInt(listItemsCount, 10) - 1);
      }
    }
  }

  static addToListSuccessHandler(dataObj, jqXHR, $el, productId, thumbnail) {
    const self = this;
    const listItems = Storage.getSession('listItems');
    const listItemsCount = Storage.getSession('listItemsCount');
    thumbnail.$el.trigger('component::productThumbnail::heartClicked', ['wishlist add', productId]);
    if (dataObj.errors) {
      self.showHeartConfirmationMsg('Unable To Add', $el, thumbnail.homepageRecentlyViewedEnabled);
    } else {
      if (dataObj.CustomerList && dataObj.CustomerList.list && dataObj.CustomerList.list.length > 0 && dataObj.CustomerList.list[0].listGuid) {
        Storage.setSession('listGuid', dataObj.CustomerList.list[0].listGuid);
        if (listItems) {
          if (listItems.indexOf(productId) === -1) {
            Storage.setSession('listItems', `${listItems},${productId}`);
          }
        } else {
          Storage.setSession('listItems', `${productId}`);
        }
      }
      if (dataObj.CustomerList && dataObj.CustomerList.user) {
        if (dataObj.CustomerList.user.guid && !Cookie.get('macys_online_guid')) {
          self.setMacysOnlineCookie('macys_online_guid', dataObj.CustomerList.user.guid);
        }
        if (dataObj.CustomerList.user.id && !Cookie.get('macys_online_uid')) {
          self.setMacysOnlineCookie('macys_online_uid', dataObj.CustomerList.user.id);
        }
      }
      if (listItemsCount) {
        Storage.setSession('listItemsCount', parseInt(listItemsCount, 10) + 1);
      } else {
        Storage.setSession('listItemsCount', 1);
      }
      $el.removeClass('icon-gen-heart-gr-large').addClass('icon-gen-heart-red-large').attr('title', 'Remove From Default List').attr('aria-label', 'Remove From Default List');
      self.showHeartConfirmationMsg('Added To List', $el, thumbnail.homepageRecentlyViewedEnabled);
    }
  }

  static setMacysOnlineCookie(cookieId, userId) {
    const timeoutWindow = 2592000000;
    Cookie.set(cookieId, userId, undefined, {
      expires: new Date(new Date().getTime() + timeoutWindow),
    });
  }

  static showHeartConfirmationMsg(msg, $el, homepageRecentlyViewedEnabled) {
    const className = homepageRecentlyViewedEnabled ? 'confirmMsgRedOutLine' : 'confirmMsg';
    $el.closest('.productThumbnail').find('.listHeartWrap').after(`<div class=${className}>${msg}</div>`);
    const msgElement = $el.closest('.productThumbnail').find(`.${className}`);
    msgElement.delay(1000).fadeOut(1000, function () {
      $(this).remove();
    });
  }
}
